// PlatformFeeCard.tsx – card showing platform fee (with tax) and non-refundable disclaimer
import React from "react";
import infoIcon from "../../../assets/images/info.png";

type Props = {
    amount: number; // platform fee amount including tax
    title?: string;
    note?: string;
    disclaimer?: string;
    currency?: string;
    className?: string;
};

const fmt = (n: number, currency = "USD") =>
    n.toLocaleString(undefined, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
    });

export default function PlatformFeeCard({
    amount,
    title = "Platform Fee",
    note = "Calculated from package total plus applicable tax.",
    disclaimer = "All platform fees are non-refundable.",
    currency = "USD",
    className = "",
}: Props) {

    return (
        <div className={["w-full", className].join(" ")}>
            <div className="w-full rounded-2xl bg-[#F7F8FA] px-4 py-3 sm:px-5 sm:py-3">
                <div className="flex items-center justify-between gap-3">
                    <p className="text-sm font-[400] text-[#19191C]">{title}</p>
                    <p className="text-sm font-[400] text-[#19191C]">{fmt(amount, currency)}</p>
                </div>
                <div className="flex items-start gap-2 text-xs text-gray-500">
                    {/* <img src={infoIcon} className="w-4 h-4 shrink-0" alt="" /> */}
                    <span className="font-[400] text-[10px] text-[#8D8D8D]">({disclaimer})</span>
                </div>
            </div>
            {/* <p className="mt-1 pl-2 text-[11px] text-orange-600">{disclaimer}</p> */}
        </div>
    );
}
